import React from 'react';
import PropTypes from 'prop-types';
import { Components, Utils, translate } from 'versafleet-core';
import { connect } from 'react-redux';
import ReduxActions from 'reduxActions';
import withRouterHooks from 'utils/routerHelper';
import TaskModule from '../task';

class JobNewTaskForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      form: this._getDefaultForm(),
      error: {},
      isChanged: false,
    };
    this.onFormChange = this._onFormChange.bind(this);
  }

  UNSAFE_componentWillMount() {
    if (this.props.job.state === 'submitted'
        || this.props.job.state === 'in_progress'
        || this.props.job.state === 'completed') {
      if (this.props.location.pathname.includes('submissions')) {
        this.props.navigate('/submissions');
      } else {
        this.props.navigate('/in_progress');
      }
    }

    this.props.dispatch(ReduxActions.constant.fetchList());
    this.props.dispatch(ReduxActions.customFieldGroup.fetchOptionCustomFieldGroupList());
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.customFieldGroups !== this.props.customFieldGroups
      && !Utils.Helper.isNullOrUndefined(nextProps.account.addons_setting)
      && nextProps.account.addons_setting.custom_field) {
      const customFieldGroupId = this.state.form.custom_field_group_id;

      this.setState(prevState => ({
        form: Utils.Helper.setFilter(
          prevState.form,
          'custom_fields_attributes',
          this._getCustomFieldsDefaultForm(prevState.form.custom_fields_attributes,
            nextProps.customFieldGroups[customFieldGroupId]),
        ),
      }));
    }
  }

  _getDefaultForm() {
    const baseTask = this.props.job.base_task || {};
    return {
      job_id: Utils.Router.getParams().id,
      job_type: this.props.job.job_type,
      address_attributes: {
        name: null,
        line_1: null,
        country: null,
        zip: null,
        contact_person: null,
        contact_number: null,
        email: null,
      },
      time_type: baseTask.time_type,
      time_from: baseTask.time_from || null,
      time_to: baseTask.time_to || null,
      time_window_id: Utils.Helper.isNullOrUndefined(baseTask.time_window)
        ? baseTask.time_window_id : baseTask.time_window.id,
      epod_attachments_attributes: [],
      custom_field_group_id: null,
      custom_fields_attributes: (this.props.account.addons_setting || {}).custom_field
        ? [] : undefined,
    };
  }

  _getCustomFieldsDefaultForm = (customFields, customFieldGroup) => {
    if (Utils.Helper.isNullOrUndefined(customFieldGroup)) {
      return [];
    }

    return customFieldGroup.custom_field_descriptions.map((item) => {
      const customField = Utils.Helper.isNullOrUndefined(customFields) ? {}
        : customFields.find((field) => {
          const id = Utils.Helper.isNullOrUndefined(field.custom_field_description)
            ? field.custom_field_description_id : field.custom_field_description.id;

          return id === item.id;
        });
      const value = (customField || {}).value;
      const subvalue = (customField || {}).subvalue;
      return {
        custom_field_description_id: item.id,
        value,
        subvalue,
        id: (customField || {}).id,
      };
    });
  }

  _onFormChange(fieldName, value, index, isDelete, shouldChange = true) {
    if (fieldName === 'custom_field_group_id') {
      this.setState(prevState => ({
        form: Utils.Helper.setFilter(prevState.form, null, {
          custom_field_group_id: value,
          custom_fields_attributes: [],
        }),
        isChanged: shouldChange ? true : prevState.isChanged,
      }));

      if (!Utils.Helper.isNullOrUndefined(value)) {
        this.props.dispatch(ReduxActions.customFieldGroup.fetch(value));
      }
    } else if (fieldName === 'billing_account_id') {
      if (value && value !== '') {
        this.props.dispatch(ReduxActions.billingAccount.fetch(value));
      }
      this.setState(prevState => ({
        form: {
          ...prevState.form,
          billing_account_id: value,
        },
      }));
    } else {
      this.setState(prevState => ({
        form: Utils.Helper.setFilter(prevState.form, fieldName, value, index, isDelete),
        isChanged: shouldChange ? true : prevState.isChanged,
      }));
    }
  }

  _renderMenu() {
    return (
      <Components.Form.Title>
        <Components.Form.Title.Item
          id="vf-job__new-task-form__title__job-redirect"
          onClick={() => (this.props.location.pathname.includes('submissions')
            ? this.props.navigate(`/submissions/jobs/${Utils.Router.getParams().id}`)
            : this.props.navigate(`/in_progress/jobs/${Utils.Router.getParams().id}`))}
        >
          {this.props.job.guid}
        </Components.Form.Title.Item>
        <Components.Form.Title.Item isHighlighted>
          {this.props.strings.Task.form.menu.newTask}
        </Components.Form.Title.Item>
      </Components.Form.Title>
    );
  }

  _renderRightPanel() {
    return (
      <Components.Form.RightPanel>
        <Components.Button
          iconClassName="versa-completed"
          id="vf-job__new-task-form__right-panel__save-button"
          onClick={() => {
            Utils.FullScreenLoading.FullScreenLoadingManager.open(
              this.props.strings.Task.form.saving,
            );
            this.props.dispatch(ReduxActions.task.create({
              ...this.state.form,
              job_type: undefined,
            }))
              .then(() => {
                if (this.props.location.pathname.includes('submissions')) {
                  this.props.navigate(`/submissions/jobs/${Utils.Router.getParams().id}`);
                } else {
                  this.props.navigate(`/in_progress/jobs/${Utils.Router.getParams().id}`);
                }
                this.props.dispatch(ReduxActions.job.fetch(Utils.Router.getParams().id));
              })
              .catch((error) => {
                this.setState({ error });
              })
              .then(() => {
                Utils.FullScreenLoading.FullScreenLoadingManager.close();
              });
          }}
        >
          {this.props.strings.Task.form.buttons.save}
        </Components.Button>
      </Components.Form.RightPanel>
    );
  }

  render() {
    return (
      <Components.Form.CoreLayout
        isChanged={this.state.isChanged}
        onClose={() => (this.props.location.pathname.includes('submissions')
          ? this.props.navigate('/submissions')
          : this.props.navigate('/in_progress'))}
        rightPanel={this._renderRightPanel()}
        title={this._renderMenu()}
      >
        <TaskModule.Edit
          constant={this.props.constant}
          customFieldGroups={this.props.customFieldGroups}
          customer={this.props.customer}
          data={this._getDefaultForm()}
          error={this.state.error}
          form={this.state.form}
          id="vf-job__new-task-form"
          isNewTask
          onFormChange={this.onFormChange}
          optionCustomFieldGroups={this.props.optionCustomFieldGroups}
        />
      </Components.Form.CoreLayout>
    );
  }
}

JobNewTaskForm.propTypes = {
  account: PropTypes.shape({
    addons_setting: PropTypes.shape({
      custom_field: PropTypes.number,
    }),
  }).isRequired,
  constant: PropTypes.shape().isRequired,
  customFieldGroups: PropTypes.shape({}),
  customer: PropTypes.shape().isRequired,
  dispatch: PropTypes.func.isRequired,
  job: PropTypes.shape({
    base_task: PropTypes.shape(),
    guid: PropTypes.string,
    job_type: PropTypes.string,
    state: PropTypes.string,
  }),
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  navigate: PropTypes.func.isRequired,
  optionCustomFieldGroups: PropTypes.arrayOf(PropTypes.shape({})),
  strings: PropTypes.shape({
    Task: PropTypes.shape({
      form: PropTypes.shape({
        menu: PropTypes.shape({
          newTask: PropTypes.string,
        }),
        saving: PropTypes.string,
        buttons: PropTypes.shape({
          save: PropTypes.string,
        }),
      }),
    }),
  }).isRequired,
};

JobNewTaskForm.defaultProps = {
  customFieldGroups: {},
  optionCustomFieldGroups: [],
  job: {
    guid: '',
    job_type: '',
  },
};

const mapStateToProps = (state, ownProps) => {
  const {
    account, customFieldGroup, profile, constant, job,
  } = state;
  return {
    account: account.account,
    constant: constant.constant,
    customer: profile.profile,
    customFieldGroups: customFieldGroup.customFieldGroups,
    optionCustomFieldGroups: customFieldGroup.optionCustomFieldGroups,
    job: job.jobs[ownProps.params.id],
  };
};

export default withRouterHooks(connect(mapStateToProps)(translate('')(JobNewTaskForm)));
